export default __webpack_public_path__ + "static/media/xps-Qrjx2nTBHVo-unsplash.70009d1b.jpg";